module.exports = __webpack_public_path__ + "static/media/cammino_santiago_3.2bae478d.jpg";